import { SmimeExecutedData } from "@dashboard-v3/api";
import { Box, capitalize, Divider, Grid, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";

interface Props {
  actions: SmimeExecutedData["actions"];
}

export default function SmimeDetails(props: Props) {
  const { t } = useTranslation(["tracing", "rules"]);
  const { actions } = props;

  return (
    <Box style={{ marginTop: 10, width: "100%" }}>
      {actions.map((item, index) => (
        <Box key={item.action}>
          <Box ml={2} mb={2}>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              spacing={2}
            >
              <Grid item xs={3}>
                <Box display="flex" flexDirection="column">
                  <Typography
                    color="textSecondary"
                    component="span"
                    variant="caption"
                  >
                    {t("action")}
                  </Typography>
                  <Box>{t(`rules:smimeAction.${item.action}.label`)}</Box>
                </Box>
              </Grid>
              <Grid item xs={3}>
                <Box display="flex" flexDirection="column">
                  <Typography
                    color="textSecondary"
                    component="span"
                    variant="caption"
                  >
                    {t("delivered.status")}
                  </Typography>
                  <Box>{capitalize(item.type.toLowerCase())}</Box>
                </Box>
              </Grid>
              <Grid item xs={4}>
                {Boolean(item.details.email) && (
                  <Box display="flex" flexDirection="column">
                    <Typography
                      color="textSecondary"
                      component="span"
                      variant="caption"
                    >
                      {t("typeToLabels.EMAIL")}
                    </Typography>
                    <Box>{item.details.email}</Box>
                  </Box>
                )}
              </Grid>
            </Grid>
          </Box>
          {index < actions.length - 1 && (
            <Divider style={{ marginBottom: 10 }} />
          )}
        </Box>
      ))}
    </Box>
  );
}
